import dot from "dot-object"
import dayjs from "dayjs"
const locale = window.localStorage["covergo-locale"] || "en-US"
import { i18n } from "@/locales/setup.js"

export const clone = obj => JSON.parse(JSON.stringify(obj))

// Takes {"a.a.a": "hello"} --> {a: {a: {a: "hello"}}}
// More here: https://www.npmjs.com/package/dot-object
// TODO: probably not needed anymore as this is part of JForm component now
export const parseDotNotation = obj => {
	return dot.object(obj)
}

// Converting binary to octect stream
// For download of excel files
export const convertToOctetStream = s => {
	let buf = new ArrayBuffer(s.length) //convert s to arrayBuffer
	let view = new Uint8Array(buf) //create uint8array as viewer
	for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff //convert to octet
	return buf
}

/**
 * Converting date from 01/01/2018 to 2018-01-01
 */
export const transformDate = date => {
	if (!date) return null
	return date
		.split("/")
		.reverse()
		.join("-")
}

/**
 * Converting 01/01/2019 10:10:10 to 2019-01-01T10:10:10+08:00
 *
 */
export const transformDateTime = dateTime => {
	if (!dateTime) return null
	const split = dateTime.split(" ")
	const date = split && split[0] ? split[0] : null
	const time = split && split[1] ? split[1] : null

	return `${date
		.split("/")
		.reverse()
		.join("-")}T${time}${getUtcOffsetInHours()}`
}

export const getUtcOffsetInHours = () => {
	const hour = dayjs().utcOffset() / 60

	if (hour < 10 && hour > 0) return `+0${hour}:00` // for +01:00 to +09:00
	if (hour > -10 && hour < 0) return `-0${hour}:00` // for -01:00 to -09:00
	if (hour > 10) return `+${hour}:00` // for
	if (hour < -10) return `-${hour}:00`
}

/**
 * @description
 * Will go through contacts of client and returns particular contact value
 * @param type - whe we want to retrieve from contacts array, e.g. "email", "phone"
 * @param contacts - array of client contacts that we get from graphql,
 * specifically individuals.list.contacts and companies.list.contacts
 */
export const getClientContact = (type, contacts = []) => {
	if (!type || !contacts || contacts.length === 0) return null

	const foundItem = contacts.find(item => item.type === type)
	return foundItem ? foundItem.value : null
}

/**
 * @description
 * Will go through identities of client and returns particular identity value
 * @param type - whe we want to retrieve from identities array, e.g. "email", "phone"
 * @param identities - array of client identities that we get from graphql,
 * specifically individuals.list.identities and companies.list.identities
 */
export const getClientIdentity = (type, identities = []) => {
	if (!type || !identities || identities.length === 0) return null

	const foundItem = identities.find(item => item.type === type)
	return foundItem ? foundItem.value : null
}

/**
 * @description
 * It will display facts as string "question1: answer1; qestion2: answer2; ..."
 * @param facts - it's an array that we receive from graphql individuals.list.facts
 */
export const serializeClientFacts = facts => {
	if (!facts) return null

	return facts.map(item => `${item.type}: ${item.value}; `).join("")
}

/**
 * @description
 * It will display addresses as string "Address Type: Home, Street: Queens Road; Address Type: Office, Street: Kings Road...;"
 * @param facts - it's an array that we receive from graphql individuals.list.facts
 */
export const serializeClientAddresses = addresses => {
	if (!addresses) return null

	return addresses
		.map(item => {
			if (!item.type || !item.fields) return

			const fields = JSON.parse(item.fields)
			return (
				`Address Type: ${item.type}, ` +
				Object.keys(fields)
					.map(key => `${key}: ${fields[key] ? fields[key] : ""}, `)
					.join("") +
				"; "
			)
		})
		.join("")
}

/** Helper to make first letter of a string uppercase */
export const firstLetterUppercase = string => {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

export const parseFactValue = values => {
	if (!values) return null
	if (values.stringValue) return values.stringValue
	if (values.numberValue) return values.numberValue
	if (values.dateValue) return dayjs(values.dateValue).format("DD/MM/YYYY")
	if (values.booleanValue === true) return i18n.messages[locale].yes
	if (values.booleanValue !== true) return i18n.messages[locale].no
	if (values.arrayValue) return values.arrayValue.stringValue
}

export const unCamelCase = value => {
	if (!value) return ""
	return value
		.replace(/([A-Z])/g, " $1") // insert a space before all caps
		.toLowerCase()
}
